// Component for displaying and managing occasions
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Occasions = () => {
    const [occasions, setOccasions] = useState([]);
    const [occasionNameSearchTerm, setOccasionNameSearchTerm] = useState('');
    const [locationSearchTerm, setLocationSearchTerm] = useState('');
    const [outfitSearchTerm, setOutfitSearchTerm] = useState('');
    const [expandedOutfits, setExpandedOutfits] = useState({});
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchOccasions(); // Fetch occasions data on component load
    }, []);

    const fetchOccasions = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('http://localhost:3000/api/occasions', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setOccasions(response.data);
        } catch (error) {
            console.error('Error fetching occasions:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`http://localhost:3000/api/occasions/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setOccasions(occasions.filter(occasion => occasion._id !== id));
        } catch (error) {
            console.error('Error deleting occasion:', error);
        }
    };

    const toggleOutfitDetails = (occasionId, outfitId) => {
        setExpandedOutfits(prevState => ({
            ...prevState,
            [occasionId]: {
                ...prevState[occasionId],
                [outfitId]: !prevState[occasionId]?.[outfitId], // Toggle for the specific occasion and outfit
            }
        }));
    };        

    const filteredOccasions = occasions.filter(occasion => {
        // Search by occasion name
        const matchesOccasionName = occasion.occasion_name.toLowerCase().includes(occasionNameSearchTerm.toLowerCase());

        // Search by location
        const matchesLocationName = occasion.location.some(loc => loc.toLowerCase().includes(locationSearchTerm.toLowerCase()));

        // Search by outfit items (array of objects)
        const matchesOutfitItems = occasion.outfits.some(outfit => 
            outfit.outfit_name.toLowerCase().includes(outfitSearchTerm.toLowerCase()) ||
            outfit.occasion.some(occ => occ.toLowerCase().includes(outfitSearchTerm.toLowerCase())) || 
            outfit.clothing_items.some(cloth => 
                cloth.cloth_name.toLowerCase().includes(outfitSearchTerm.toLowerCase()) ||  // Accessing the correct string property
                cloth.color.some(col => col.toLowerCase().includes(outfitSearchTerm.toLowerCase())) || 
                cloth.category.some(cat => cat.toLowerCase().includes(outfitSearchTerm.toLowerCase())) ||
                cloth.season.some(sea => sea.toLowerCase().includes(outfitSearchTerm.toLowerCase()))
            )
        );

        return matchesOccasionName && matchesLocationName && matchesOutfitItems;
    });

    return (
        <div className="occasions-container">
            <h1><strong>𝒪𝒸𝒸𝒶𝓈𝒾𝑜𝓃𝓈 ({occasions.length})</strong></h1>

            {/* Dropdown Button */}
            <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="dropdown-btn">
                <i className="fa-solid fa-magnifying-glass"></i> <strong>𝒮𝑒𝒶𝓇𝒸𝒽 𝐹𝒾𝓁𝓉𝑒𝓇𝓈</strong>
            </button>
            <button onClick={() => navigate('/create-occasion')} className="create-occasion-btn">
            <i className="fa-solid fa-plus"></i> <strong>𝒞𝓇𝑒𝒶𝓉𝑒 𝒪𝒸𝒸𝒶𝓈𝒾𝑜𝓃</strong>
            </button>

            {/* Search Filters */}
            {isDropdownOpen && (
                <div className="search-container">
                    <label>
                        <strong>Occasion Name:</strong>
                        <input
                            type="text"
                            placeholder="Search by occasion name"
                            value={occasionNameSearchTerm}
                            onChange={(e) => setOccasionNameSearchTerm(e.target.value)}
                        />
                    </label>
                    <label>
                        <strong>Location:</strong>
                        <input
                            type="text"
                            placeholder="e.g. Coffee, Gym, Bar"
                            value={locationSearchTerm}
                            onChange={(e) => setLocationSearchTerm(e.target.value)}
                        />
                    </label>
                    <label>
                        <strong>Outfits:</strong>
                        <input
                            type="text"
                            placeholder="Search by outfit name, clothes included or occasions"
                            value={outfitSearchTerm}
                            onChange={(e) => setOutfitSearchTerm(e.target.value)}
                        />
                    </label>
                </div>
            )}

            <div className="occasions-grid">
                {filteredOccasions.map((occasion) => (
                    <div key={occasion._id} className="occasion-item">
                        <h3><strong>{occasion.occasion_name}</strong></h3>
                        <p><strong>Location\-s:</strong> {occasion.location.join(', ')}</p>
                        <p><strong>Description: </strong>{occasion.description}</p>
                        <p><strong>Outfit\-s: </strong></p>
                        <div className="outfits-list">
                            {occasion.outfits.map((outfit) => (
                                <div key={outfit._id} className={`outfit-item ${expandedOutfits[occasion._id]?.[outfit._id] ? 'expanded' : ''}`}>
                                    <button
                                        onClick={() => toggleOutfitDetails(occasion._id, outfit._id)}  // Pass both occasionId and outfitId
                                        className="outfit-title"
                                    >
                                        <strong>{outfit.outfit_name}</strong>
                                    </button>

                                    <div className={`clothing-items outfit-details`}>
                                        {expandedOutfits[occasion._id]?.[outfit._id] && outfit.clothing_items.map((cloth) => (
                                            <div key={cloth._id} className="clothing-item">
                                                <img src={cloth.image_url} width="100" alt={cloth.cloth_name} />
                                                <p>{cloth.cloth_name}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className="occasion-actions">
                            <button onClick={() => navigate(`/edit-occasion/${occasion._id}`)} className="edit-btn">
                                <i className="fa-solid fa-pencil"></i> <strong>𝐸𝒹𝒾𝓉</strong>
                            </button>
                            <button onClick={() => handleDelete(occasion._id)} className="delete-btn">
                                <i className="fa-solid fa-trash"></i> <strong>𝒟𝑒𝓁𝑒𝓉𝑒</strong>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Occasions;